import { MenuItem } from 'react-contextmenu';
import React from 'react';
import { Tooltip } from '@fluentui/react-components';

export type IContextMenuItemProps = {
  available?: boolean;
  key: string;
  label: string;
  onClick: (value?: any, close?: () => void, rowIndex?: number) => void;
  rowIdx: number;
  disabled?: boolean;
  hint?: string;
};

const ContextMenuItem = ({ available, label, onClick, rowIdx, disabled, hint }: IContextMenuItemProps) => {
  if (!available) return null;

  const content = (
    <MenuItem
      onClick={(e) => {
        e.preventDefault();
        onClick(null, undefined, rowIdx);
      }}
      disabled={disabled}
    >
      {label}
    </MenuItem>
  );

  if (hint) {
    return (
      <Tooltip content={hint} relationship={'label'} positioning={'after'}>
        <div>{content}</div>
      </Tooltip>
    );
  }

  return content;
};
ContextMenuItem.defaultProps = {
  available: true,
};

export default ContextMenuItem;
